import { Link, Outlet, useNavigate, useSearchParams } from "react-router-dom";
import {
  ArrowLeft,
  BarChart3,
  BookOpen,
  GraduationCap,
  MapPin,
  School,
  ShieldAlert,
  Target,
  Users,
} from "lucide-react";
import { PAT_NAV_ITEMS } from "@/components/pat/patConstants";
import SidebarUserCard from "@/components/SidebarUserCard";
import "../pages/PatDashboard.css";
import "../styles/sqafSidebarShell.css";

const SIDEBAR_ICONS = {
  executive: BarChart3,
  geography: MapPin,
  school: School,
  subject: BookOpen,
  grade: Users,
  outcome: Target,
  risk: ShieldAlert,
};

const StandalonePatLayout = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "executive";

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/login");
  };

  const goToTab = (tabId) => {
    const next = new URLSearchParams(searchParams);
    if (tabId === "executive") next.delete("tab");
    else next.set("tab", tabId);
    navigate({ pathname: "/pat-dashboard", search: next.toString() ? `?${next.toString()}` : "" });
  };

  return (
    <div className="pat-dashboard-root">
      <div className="app-shell">
        <aside className="sq-sidebar" aria-label="PAT dashboard sidebar">
          <div className="sq-sidebar-brand">
            <Link className="sq-sidebar-brand-main" to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <span className="sq-brand-icon" aria-hidden="true">
                <BarChart3 strokeWidth={2} width={22} height={22} />
              </span>
              <span className="sq-brand-copy">
                <strong>PAT Assessment</strong>
                <span>Visual KPI Dashboard</span>
              </span>
            </Link>
          </div>

          <div className="sq-sidebar-scroll">
            <section className="sq-sidebar-section">
              <div className="sq-section-title">Visual Views</div>
              <nav className="sq-nav">
                {PAT_NAV_ITEMS.map(({ id, label }) => {
                  const Icon = SIDEBAR_ICONS[id] || BarChart3;
                  return (
                    <button
                      key={id}
                      type="button"
                      className={`sq-nav-item${activeTab === id ? " active" : ""}`}
                      onClick={() => goToTab(id)}
                    >
                      <Icon strokeWidth={2} />
                      {label}
                    </button>
                  );
                })}
              </nav>
            </section>
          </div>

          <div className="sq-sidebar-footer">
            <SidebarUserCard user={user} onLogout={handleLogout} />
          </div>
        </aside>

        <main className="main">
          <header className="topbar">
            <div className="topbar-inner">
              <div className="breadcrumb">
                <Link to="/">Maharashtra</Link>
                <span>›</span>
                <b>PAT-2 & PAT-3 Assessment</b>
              </div>
              <div className="top-actions">
                <span className="filter-chip">
                  Scope <b>Pune / Common District</b>
                </span>
                <span className="filter-chip">
                  Cycle <b>PAT-2 → PAT-3</b>
                </span>
                <Link to="/" className="filter-chip" title="Back to landing" style={{ display: "inline-flex" }}>
                  <ArrowLeft strokeWidth={2} width={16} height={16} />
                </Link>
              </div>
            </div>
          </header>
          <Outlet context={{ user, activeTab }} />
        </main>
      </div>
    </div>
  );
};

export default StandalonePatLayout;
